/**
 * Feature Flags
 * Controls which UI features are enabled or disabled
 * Default value is OFF if not specified
 *
 * Example Usage:
 * import { FEATURE_FLAGS, isFeatureEnabled } from '../constants/featureFlags';
 *
 * if (isFeatureEnabled('PAYMENTS')) {
 *   // Show payments UI
 * }
 */

export const FEATURE_FLAGS = {
  // Payment processing with Finix integration
  PAYMENTS: false,

  // Messaging system
  MESSAGES: false,

  // Add more flags here as needed
  // EXAMPLE_FEATURE: true,
};

/**
 * Helper function to check if a feature is enabled
 * Returns false by default if flag doesn't exist
 * @param {string} flagName - The feature flag name
 * @returns {boolean} - Whether the feature is enabled
 */
export const isFeatureEnabled = (flagName) => {
  return FEATURE_FLAGS[flagName] ?? false;
};

/**
 * Helper function to check multiple features (AND logic)
 * @param {string[]} flagNames - Array of feature flag names
 * @returns {boolean} - True if ALL features are enabled
 */
export const allFeaturesEnabled = (flagNames) => {
  return flagNames.every(flag => isFeatureEnabled(flag));
};

/**
 * Helper function to check if any features are enabled (OR logic)
 * @param {string[]} flagNames - Array of feature flag names
 * @returns {boolean} - True if ANY feature is enabled
 */
export const anyFeatureEnabled = (flagNames) => {
  return flagNames.some(flag => isFeatureEnabled(flag));
};
